import React from 'react';
import c from 'classnames';
import { SearchAutosuggest as RSKSearchAutosuggest } from '@uncinc/react-searchkit';
import { SearchAutosuggestProps as Type } from '@uncinc/react-searchkit/dist/components/Autosuggest';

import SearchBar, { SearchBarProps } from '../Bar';

import './style.scss';

export interface SearchAutosuggestProps {
  autosuggestProps: Type;
  searchbarProps?: SearchBarProps;
  type?: 'primary' | 'secondary';
}

const SearchAutosuggest: React.FC<SearchAutosuggestProps> = (props) => {
  const {
    autosuggestProps,
    searchbarProps,
    type,
  } = props;

  const classes = c('SearchAutosuggest', {
    ...(type && { [`SearchAutosuggest--${type}`]: type }),
  });

  return (
    <div className={classes}>
      <RSKSearchAutosuggest
        {...autosuggestProps}
        renderInputComponent={(inputProps) => (
          <SearchBar
            {...searchbarProps}
            {...inputProps}
            type={type}
          />
        )}
      />
    </div>
  );
};

export default SearchAutosuggest;
